import { pageSizes, pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';

export default {
  name: 'sale-drug',
  mixins: [ pageSize ],
  data() {
    return {
      pageSizess: pageSizes,
      pickerOptionss: pickerOptions,
      tableData: [], // 消息列表
      total: 0, // 总数据条数
      isLoading: false,
      time: [],
      query: {
        sendTimeStart: '',
        sendTimeEnd: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
    };
  },

  methods: {
    // 按时间搜索消息记录列表
    selectMessageInfo() {
      this.getListData(1);
    },
    // 获取消息列表
    getListData(type) {
      // 初始化页码
      if (type === 1) {
        this.page = 0;
        this.currentPage = 1;
      }
      if (this.time) {
        const [startTime, endTime] = this.time;
        this.query.sendTimeStart = startTime;
        this.query.sendTimeEnd = endTime;
      } else {
        this.query.sendTimeStart = '';
        this.query.sendTimeEnd = '';
      }
      this.$api.memberManagement.getCouponRecord(this.query).then((res) => {
        this.tableData = res.couponRecords || [];
        this.total = res.totalSize || 0;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getListData(1);
    },
    // 翻页
    handleCurrentChange(value) {
      this.page = value - 1;
      this.getListData();
    },
  },
  filters: {
    // 获取优惠券状态
    getStatus(status) {
      const statusBak = Number(status);
      return statusBak === 1 ? '未使用' : '已使用';
    },
  },
  watch: {

  },
  mounted() {
    this.time = startDate();
    this.getListData();
  },
}
